module.exports = __webpack_public_path__ + "img/materials.1895cbdb.svg";